define([
	"dojo/_base/lang",
	"dojo/dom-class",
	"csi/def/Action",
	"csi/view/PluginFactory",
	"csi/view/ToolbarPluginToggleButton"
], function(lang,domClass,Action,PluginFactory,ToolbarPluginToggleButton) {

	return PluginFactory.declare("htmlToolbars", ToolbarPluginToggleButton, {
		constructor: function() {
			this.defAction = lang.mixin(new Action(), {m_id: "HtmlToolbars"});
			this.defAction.resolve();
		},

		isToggledInitially: function(/*Context?*/ctx) {
			// summary: return true if button should be in toggled (checked) state
			return !domClass.contains(this._getToggleNode(), "htmlHideToolbars");
		},

		onChange: function(/*Object*/value, /*Action*/action) {
			// summary: user callback for when widget is clicked (buttons)
			domClass.toggle(this._getToggleNode(), "htmlHideToolbars", !value);
		},

		_getToggleNode: function() {
			// summary: return DOMNode on which to apply the CSS
			return this.getView().contentNode.domNode;
		}
	});
});